/** A file input value - one file, many or none - as a list. */
export const toFiles = (value: unknown): File[] => {
  if (Array.isArray(value)) return value.filter((v) => v instanceof File);
  return value instanceof File ? [value] : [];
};
